var _sodipodiNamedview, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasketball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 31.75 31.750002",
    id: "svg1696",
    inkscapeVersion: "1.1.1 (3bf5ae0d25, 2021-09-20)",
    sodipodiDocname: "basketball.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1698",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapePageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    "inkscapeDocument-units": "px",
    showgrid: "false",
    inkscapeZoom: 4.3994184,
    inkscapeCx: 23.75314,
    inkscapeCy: 81.94265,
    "inkscapeWindow-width": 2560,
    "inkscapeWindow-height": 1377,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "layer1",
    units: "px"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1693"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Ebene 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    style: {
      display: "inline"
    },
    transform: "translate(-0.03787441,-0.00135587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 5.0136669,12.736906 2.147817,-0.523875 c 0.227788,-0.636411 0.60138,-1.28905 1.051313,-1.796697 -0.209762,-0.154164 -0.483023,-0.217664 -0.755438,-0.151342 l -3.679378,0.897467 c -0.455856,0.111125 -0.752824,0.550686 -0.685849,1.015295 l 0.595588,4.129617 c 0.06573,0.453672 0.455164,0.780697 0.900814,0.780697 0.04329,0 0.08696,-0.0028 0.131057,-0.0092 0.498017,-0.07197 0.843492,-0.533753 0.771702,-1.031875 l -0.477626,-3.310114",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19.860109,5.5353009 c -0.467149,-0.187325 -0.997585,0.039511 -1.184416,0.5065889 l -1.432067,3.5732866 -2.998082,1.6280686 c 0.310339,0.5715 0.451591,1.2192 0.40005,1.856317 l 3.756414,-2.040114 c 0.186725,-0.101247 0.331963,-0.264583 0.410774,-0.461786 L 20.366945,6.719576 C 20.554093,6.2524981 20.327255,5.7222731 19.860109,5.5353009",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.089177,25.955138 11.41549,20.391832 H 7.5017029 l -1.934881,4.786137 -4.507988,3.903839 c -0.50711699,0.438855 -0.56223899,1.2065 -0.12319599,1.713089 0.24032799,0.277636 0.57877599,0.420158 0.91901299,0.420158 0.281809,0 0.564998,-0.09807 0.794579,-0.296686 l 4.729283,-4.09575 c 0.145379,-0.125942 0.258656,-0.284692 0.33087,-0.462845 l 1.7983555,-4.447823 2.8384856,4.298245 -3.3474026,1.902178 c -0.5833185,0.331259 -0.7874005,1.072798 -0.4560005,1.655939 0.2239435,0.394053 0.6345765,0.614892 1.0572395,0.614892 0.203377,0 0.4093986,-0.05115 0.5991576,-0.15875 l 4.476433,-2.543881 c 0.292276,-0.166158 0.502567,-0.446264 0.58099,-0.772936 0.07811,-0.327025 0.01774,-0.671689 -0.167464,-0.9525",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.883873,18.177446 c 0.762459,-1.645709 1.561606,-3.338337 1.834868,-4.971345 0.131586,-0.809625 -0.200237,-1.573742 -0.626322,-2.022122 -0.263489,0.07373 -0.535904,0.113947 -0.812905,0.113947 -0.298345,0 -0.593796,-0.04515 -0.878488,-0.134056 -0.455577,-0.142522 -0.852875,-0.388408 -1.179759,-0.706966 -0.100577,-0.01588 -0.203271,-0.0314 -0.3017656,-0.04727 -0.527544,-0.09384 -1.4627945,0.879122 -1.9036255,2.119136 -0.583071,1.839031 -0.898066,3.774017 -0.752545,5.648678 h 4.6205421",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.616666,8.5099233 C 14.191111,9.8705874 12.87345,10.669629 11.67263,10.294273 10.472092,9.9189174 9.8434064,8.5113344 10.26868,7.1510232 c 0.425274,-1.360664 1.743357,-2.1597057 2.943896,-1.7843501 1.20082,0.3753556 1.829223,1.7822334 1.40409,3.1432502",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27.11823,3.1501702 c 0,1.4065251 -1.140037,2.5467029 -2.54635,2.5467029 -1.406137,0 -2.546315,-1.1401778 -2.546315,-2.5467029 0,-1.407936 1.140178,-2.54740906 2.546315,-2.54740906 1.406313,0 2.54635,1.13947306 2.54635,2.54740906",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.636367,12.78947 h 2.837957 c 0.01266,-0.737305 0.07923,-2.345619 0.419064,-2.8546776 0.280424,-0.4212163 1.618616,-2.0073053 2.319761,-2.8320998 h -8.31536 c 0.70104,0.8247945 2.038808,2.4108835 2.319796,2.8320998 0.339549,0.5090586 0.406259,2.1173726 0.418782,2.8546776 z m 3.139053,0.607484 h -3.440148 c -0.16757,0 -0.303425,-0.136172 -0.303425,-0.303742 -4.23e-4,-0.972961 -0.09952,-2.491317 -0.319581,-2.821517 -0.285115,-0.4275666 -1.893147,-2.3290384 -2.703442,-3.2748357 -0.07729,-0.089958 -0.09479,-0.2169583 -0.04505,-0.3245556 0.04932,-0.1075972 0.157092,-0.1767416 0.275731,-0.1767416 h 9.631822 c 0.118639,0 0.226413,0.069144 0.276013,0.1767416 0.04932,0.1075973 0.03182,0.2345973 -0.04547,0.3245556 -0.810577,0.9457973 -2.418609,2.8472691 -2.703301,3.2748357 -0.220063,0.3302 -0.319299,1.848556 -0.319299,2.821517 0,0.16757 -0.136137,0.303742 -0.303847,0.303742",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball);
export default __webpack_public_path__ + "static/media/basketball.b29b24eff6af9f6bf6cb89234504b472.svg";
export { ForwardRef as ReactComponent };